import { useQuery } from '@tanstack/react-query';
import type { ContractMilestone } from 'src/types/contractMilestone.type';
import { apiListContractMilestones } from 'src/features/contracts/api/contracts.api';

export const contractMilestonesKey = (projectId: string, contractId: string) =>
    ['contractMilestones', projectId, contractId] as const;

export function useContractMilestones(projectId: string, contractId: string) {
    return useQuery<ContractMilestone[]>({
        queryKey: contractMilestonesKey(projectId, contractId),
        queryFn: () => apiListContractMilestones(projectId, contractId),
        enabled: !!projectId && !!contractId,
        staleTime: 10_000,
    });
}
